"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var TilesList_1 = require("./TilesList");
var routes_1 = require("../../routes");
var ProductsGrid = /** @class */ (function (_super) {
    tslib_1.__extends(ProductsGrid, _super);
    function ProductsGrid() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProductsGrid.prototype.render = function () {
        var items = this.props.items;
        if (items.length === 0) {
            return null;
        }
        return (react_1.default.createElement(TilesList_1.TilesList, null, items.map(function (product) { return (react_1.default.createElement(TilesList_1.TileItem, { key: product.id, href: routes_1.Routes.products + ("/" + product.slug), image: product.images[0].url, title: product.preview_title, subtitle: product.preview_description })); })));
    };
    ProductsGrid = tslib_1.__decorate([
        mobx_react_1.observer
    ], ProductsGrid);
    return ProductsGrid;
}(react_1.default.Component));
exports.ProductsGrid = ProductsGrid;
